import React, { useState, useRef, useEffect } from "react";
import "./HomeData.css";
import airplane from "../../assets/airplane.png";
import rupee from "../../assets/rupee.png";
import daynight from "../../assets/daynight.png";
import travel from "../../assets/travel.png";
import arrow from "../../assets/arrow.png"
const HomeData = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Temporary selected values (shown in headings)
  const [tempSelected, setTempSelected] = useState({
    destination: "Destination",
    budget: "Budget",
    days: "Days",
    trip: "Trip Type",
  });

  // Saved values (shown below)
  const [savedData, setSavedData] = useState([]);

  const dropdownRef = useRef();

  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  // Select item → show in heading
  const handleSelect = (menu, value) => {
    setTempSelected({
      ...tempSelected,
      [menu]: value,
    });
    setActiveDropdown(null);
  };

  // Arrow click → save & reset headings
  const handleSave = () => {
    setSavedData(Object.values(tempSelected));

    // Reset headings
    setTempSelected({
      destination: "Destination",
      budget: "Budget",
      days: "Days",
      trip: "Trip Type",
    });

    setActiveDropdown(null);
  };

  // Outside click close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="hero-content">
      <div className="hero-heading-content">
        <h1>Discover Adventure Places</h1>
        <p>Find the perfect destination for your next trip</p>
      </div>

      <div className="top-filter-bar" ref={dropdownRef}>
        {/* Destination */}
        <div
          className="filter-item"
          onClick={() => toggleDropdown("destination")}
        >
          <img src={airplane} alt="" className="filter-icon" />
          <span>{tempSelected.destination}</span>

          {activeDropdown === "destination" && (
            <div className="dropdown">
              {[
                "Delhi",
                "Kashmir",
                "Kerala",
                "Agra",
                "Jaipur",
                "Shimla",
                "Manali",
              ].map((item) => (
                <p key={item} onClick={() => handleSelect("destination", item)}>
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* Budget */}
        <div className="filter-item" onClick={() => toggleDropdown("budget")}>
          <img src={rupee} alt="" className="filter-icon" />
          <span>{tempSelected.budget}</span>

          {activeDropdown === "budget" && (
            <div className="dropdown">
              {["5k-10k", "10k-20k", "20k+"].map((item) => (
                <p key={item} onClick={() => handleSelect("budget", item)}>
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* Days */}
        <div className="filter-item" onClick={() => toggleDropdown("days")}>
          <img src={daynight} alt="" className="filter-icon" />
          <span>{tempSelected.days}</span>

          {activeDropdown === "days" && (
            <div className="dropdown">
              {["1-7 Days", "7-15 Days", "15+"].map((item) => (
                <p key={item} onClick={() => handleSelect("days", item)}>
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* Trip */}
        <div className="filter-item" onClick={() => toggleDropdown("trip")}>
          <img src={travel} alt="" className="filter-icon" />
          <span>{tempSelected.trip}</span>

          {activeDropdown === "trip" && (
            <div className="dropdown">
              {[
                "Solo Trip",
                "Religious Trip",
                "Honeymoon Trip",
                "Weekend Getaway Trip",
                "Beach Trip",
                "Group Trip",
                "Family Trip",
                "Festival Trip",
                "Road Trip",
              ].map((item) => (
                <p key={item} onClick={() => handleSelect("trip", item)}>
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* Arrow Section */}
        <div className="arrow-div-save-data" onClick={handleSave}>
       <img src={arrow} className="arrow-image" alt="arrow-img"/>
        </div>

     
      </div>
      <div className="saved-data">
        {savedData.map((item, index) => (
          <span key={index} className="saved-item">
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HomeData;
